/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.1.0 (NJsonSchema v10.3.3.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IGebaeudeClient {
    /**
     * Ermittelt ein GebaeudeDto-Objekt anhand der übergebenen ID
    und gibt dieses zurück
     * @param id ID des gewünschten GebaeudeDto-Objekts
     * @return Das ermittelte GebaeudeDto-Objekt
     */
    get(id: string): Observable<GebaeudeDto>;
}

@Injectable({
    providedIn: 'root'
})
export class GebaeudeClient implements IGebaeudeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Ermittelt ein GebaeudeDto-Objekt anhand der übergebenen ID
    und gibt dieses zurück
     * @param id ID des gewünschten GebaeudeDto-Objekts
     * @return Das ermittelte GebaeudeDto-Objekt
     */
    get(id: string): Observable<GebaeudeDto> {
        let url_ = this.baseUrl + "/formulare/v1/gebaeude/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GebaeudeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GebaeudeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GebaeudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GebaeudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GebaeudeDto>(<any>null);
    }
}

export interface IGewerkClient {
    /**
     * Ermittelt die Liste aller GewerkDto-Objekte aus der Datenquelle
    und gibt diese zurück
     * @return Liste aller GewerkDto-Objekte
     */
    get(): Observable<GewerkDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class GewerkClient implements IGewerkClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Ermittelt die Liste aller GewerkDto-Objekte aus der Datenquelle
    und gibt diese zurück
     * @return Liste aller GewerkDto-Objekte
     */
    get(): Observable<GewerkDto[]> {
        let url_ = this.baseUrl + "/formulare/v1/gewerk";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GewerkDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GewerkDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GewerkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GewerkDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GewerkDto[]>(<any>null);
    }
}

export interface IHochbauplaeneClient {
    /**
     * Erstellt eine Anfrage nach Hochbauplänen
     * @param anfrage (optional) Die für die Erstellung der Anfrage relevanten Daten
     * @return HTTP-Ergebnis des Erstellungsvorgangs
     */
    create(anfrage: AnfrageHochbauplaeneGebaeudeDto | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class HochbauplaeneClient implements IHochbauplaeneClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Erstellt eine Anfrage nach Hochbauplänen
     * @param anfrage (optional) Die für die Erstellung der Anfrage relevanten Daten
     * @return HTTP-Ergebnis des Erstellungsvorgangs
     */
    create(anfrage: AnfrageHochbauplaeneGebaeudeDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/formulare/v1/hochbauplaene/anfrage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(anfrage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IIdentityClient {
    /**
     * Gibt Daten des eingeloggten Benutzers zurück
     * @return Daten des eingeloggten Benutzers
     */
    getCurrentUser(): Observable<UserDto>;
    /**
     * Ermittelt die für den eingeloggten User anzuzeigenden Menü-Einträge
     * @return Die ermittelten Menü-Einträge
     */
    getUserMenu(): Observable<LinkDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class IdentityClient implements IIdentityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gibt Daten des eingeloggten Benutzers zurück
     * @return Daten des eingeloggten Benutzers
     */
    getCurrentUser(): Observable<UserDto> {
        let url_ = this.baseUrl + "/formulare/v1/identity/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * Ermittelt die für den eingeloggten User anzuzeigenden Menü-Einträge
     * @return Die ermittelten Menü-Einträge
     */
    getUserMenu(): Observable<LinkDto[]> {
        let url_ = this.baseUrl + "/formulare/v1/identity/main-menu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserMenu(<any>response_);
                } catch (e) {
                    return <Observable<LinkDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LinkDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserMenu(response: HttpResponseBase): Observable<LinkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LinkDto[]>(<any>null);
    }
}

export interface IStandortprognoseClient {
    /**
     * Erstellt eine Anfrage nach Standortprognosedaten
     * @param anfrage (optional) Die für die Erstellung der Anfrage relevanten Daten
     * @return HTTP-Ergebnis des Erstellungsvorgangs
     */
    create(anfrage: AnfrageStandortprognoseDto | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class StandortprognoseClient implements IStandortprognoseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Erstellt eine Anfrage nach Standortprognosedaten
     * @param anfrage (optional) Die für die Erstellung der Anfrage relevanten Daten
     * @return HTTP-Ergebnis des Erstellungsvorgangs
     */
    create(anfrage: AnfrageStandortprognoseDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/formulare/v1/standortprognose/anfrage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(anfrage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IWeClient {
    /**
     * Ermittelt ein WeDto-Objekt anhand der übergebenen ID
    und gibt dieses zurück
     * @param id ID des gewünschten WeDto-Objekts
     * @return Das ermittelte WeDto-Objekt
     */
    get(id: string): Observable<WeDto>;
    /**
     * Ermittelt eine Liste von WeDto-Objekten anhand eines übergebenen Suchbegriffs
    und gibt diese zurück
     * @param search Der für die Filterung zu verwendende Suchbegriff
     * @return Liste der ermittelten WeDto-Objekte
     */
    filter(search: string | null): Observable<WeDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class WeClient implements IWeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Ermittelt ein WeDto-Objekt anhand der übergebenen ID
    und gibt dieses zurück
     * @param id ID des gewünschten WeDto-Objekts
     * @return Das ermittelte WeDto-Objekt
     */
    get(id: string): Observable<WeDto> {
        let url_ = this.baseUrl + "/formulare/v1/we/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<WeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WeDto>(<any>null);
    }

    /**
     * Ermittelt eine Liste von WeDto-Objekten anhand eines übergebenen Suchbegriffs
    und gibt diese zurück
     * @param search Der für die Filterung zu verwendende Suchbegriff
     * @return Liste der ermittelten WeDto-Objekte
     */
    filter(search: string | null): Observable<WeDto[]> {
        let url_ = this.baseUrl + "/formulare/v1/we/filter?";
        if (search === undefined)
            throw new Error("The parameter 'search' must be defined.");
        else if(search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter(<any>response_);
                } catch (e) {
                    return <Observable<WeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processFilter(response: HttpResponseBase): Observable<WeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WeDto[]>(<any>null);
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten Gebaeude-Daten */
export class GebaeudeDto implements IGebaeudeDto {
    /** Extern anzeigbare ID des Gebaeude-Objekts */
    displayId!: string;
    /** Objekt-ID des Gebaeude-Objekts */
    objektId?: string | undefined;
    /** Nummer des Gebaeude-Objekts */
    nummer?: string | undefined;
    /** Adresse des Gebaeude-Objekts */
    adresse?: AdresseDto | undefined;
    /** Anzeigename des Gebaeude-Objekts */
    anzeigename?: string | undefined;
    /** Liste der dem Gebaeude-Objekt zugeordneten
Geschoss-Objekte */
    geschosse?: GeschossDto[] | undefined;

    constructor(data?: IGebaeudeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayId = _data["DisplayId"];
            this.objektId = _data["ObjektId"];
            this.nummer = _data["Nummer"];
            this.adresse = _data["Adresse"] ? AdresseDto.fromJS(_data["Adresse"]) : <any>undefined;
            this.anzeigename = _data["Anzeigename"];
            if (Array.isArray(_data["Geschosse"])) {
                this.geschosse = [] as any;
                for (let item of _data["Geschosse"])
                    this.geschosse!.push(GeschossDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GebaeudeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GebaeudeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DisplayId"] = this.displayId;
        data["ObjektId"] = this.objektId;
        data["Nummer"] = this.nummer;
        data["Adresse"] = this.adresse ? this.adresse.toJSON() : <any>undefined;
        data["Anzeigename"] = this.anzeigename;
        if (Array.isArray(this.geschosse)) {
            data["Geschosse"] = [];
            for (let item of this.geschosse)
                data["Geschosse"].push(item.toJSON());
        }
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten Gebaeude-Daten */
export interface IGebaeudeDto {
    /** Extern anzeigbare ID des Gebaeude-Objekts */
    displayId: string;
    /** Objekt-ID des Gebaeude-Objekts */
    objektId?: string | undefined;
    /** Nummer des Gebaeude-Objekts */
    nummer?: string | undefined;
    /** Adresse des Gebaeude-Objekts */
    adresse?: AdresseDto | undefined;
    /** Anzeigename des Gebaeude-Objekts */
    anzeigename?: string | undefined;
    /** Liste der dem Gebaeude-Objekt zugeordneten
Geschoss-Objekte */
    geschosse?: GeschossDto[] | undefined;
}

/** Enthält die für die Übertragung an andere Systeme relevanten Adresse-Daten */
export class AdresseDto implements IAdresseDto {
    /** Extern anzeigbare ID des Adresse-Objekts */
    displayId!: string;
    /** Straße des Adresse-Objekts */
    strasse?: string | undefined;
    /** Postleitzahl des Adresse-Objekts */
    postleitzahl?: string | undefined;
    /** Ort des Adresse-Objekts */
    ort?: string | undefined;
    /** Anzeigename des Adresse-Objekts */
    anzeigename?: string | undefined;

    constructor(data?: IAdresseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayId = _data["DisplayId"];
            this.strasse = _data["Strasse"];
            this.postleitzahl = _data["Postleitzahl"];
            this.ort = _data["Ort"];
            this.anzeigename = _data["Anzeigename"];
        }
    }

    static fromJS(data: any): AdresseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdresseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DisplayId"] = this.displayId;
        data["Strasse"] = this.strasse;
        data["Postleitzahl"] = this.postleitzahl;
        data["Ort"] = this.ort;
        data["Anzeigename"] = this.anzeigename;
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten Adresse-Daten */
export interface IAdresseDto {
    /** Extern anzeigbare ID des Adresse-Objekts */
    displayId: string;
    /** Straße des Adresse-Objekts */
    strasse?: string | undefined;
    /** Postleitzahl des Adresse-Objekts */
    postleitzahl?: string | undefined;
    /** Ort des Adresse-Objekts */
    ort?: string | undefined;
    /** Anzeigename des Adresse-Objekts */
    anzeigename?: string | undefined;
}

/** Enthält die für die Übertragung an andere Systeme relevanten Geschoss-Daten */
export class GeschossDto implements IGeschossDto {
    /** Extern anzeigbare ID des Geschoss-Objekts */
    displayId!: string;
    /** Bezeichnung des Geschoss-Objekts */
    bezeichnung?: string | undefined;
    /** Anzeigename des Geschoss-Objekts */
    anzeigename?: string | undefined;
    /** Liste der dem Geschoss-Objekt zugeordneten
Raum-Objekte */
    raeume?: RaumDto[] | undefined;

    constructor(data?: IGeschossDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayId = _data["DisplayId"];
            this.bezeichnung = _data["Bezeichnung"];
            this.anzeigename = _data["Anzeigename"];
            if (Array.isArray(_data["Raeume"])) {
                this.raeume = [] as any;
                for (let item of _data["Raeume"])
                    this.raeume!.push(RaumDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeschossDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeschossDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DisplayId"] = this.displayId;
        data["Bezeichnung"] = this.bezeichnung;
        data["Anzeigename"] = this.anzeigename;
        if (Array.isArray(this.raeume)) {
            data["Raeume"] = [];
            for (let item of this.raeume)
                data["Raeume"].push(item.toJSON());
        }
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten Geschoss-Daten */
export interface IGeschossDto {
    /** Extern anzeigbare ID des Geschoss-Objekts */
    displayId: string;
    /** Bezeichnung des Geschoss-Objekts */
    bezeichnung?: string | undefined;
    /** Anzeigename des Geschoss-Objekts */
    anzeigename?: string | undefined;
    /** Liste der dem Geschoss-Objekt zugeordneten
Raum-Objekte */
    raeume?: RaumDto[] | undefined;
}

/** Enthält die für die Übertragung an andere Systeme relevanten Raum-Daten */
export class RaumDto implements IRaumDto {
    /** Extern anzeigbare ID des Raum-Objekts */
    displayId!: string;
    /** HT-Nummer des Raum-Objekts */
    htNummer?: string | undefined;
    /** FT-Nummer des Raum-Objekts */
    ftNummer?: string | undefined;
    /** Anzeigename des Raum-Objekts */
    anzeigename?: string | undefined;

    constructor(data?: IRaumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayId = _data["DisplayId"];
            this.htNummer = _data["HtNummer"];
            this.ftNummer = _data["FtNummer"];
            this.anzeigename = _data["Anzeigename"];
        }
    }

    static fromJS(data: any): RaumDto {
        data = typeof data === 'object' ? data : {};
        let result = new RaumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DisplayId"] = this.displayId;
        data["HtNummer"] = this.htNummer;
        data["FtNummer"] = this.ftNummer;
        data["Anzeigename"] = this.anzeigename;
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten Raum-Daten */
export interface IRaumDto {
    /** Extern anzeigbare ID des Raum-Objekts */
    displayId: string;
    /** HT-Nummer des Raum-Objekts */
    htNummer?: string | undefined;
    /** FT-Nummer des Raum-Objekts */
    ftNummer?: string | undefined;
    /** Anzeigename des Raum-Objekts */
    anzeigename?: string | undefined;
}

/** Enthält die für die Übertragung an andere Systeme relevanten Gewerk-Daten */
export class GewerkDto implements IGewerkDto {
    /** Extern anzeigbare ID des Gewerk-Objekts */
    displayId!: string;
    /** Nummer des Gewerk-Objekts */
    bezeichnung?: string | undefined;

    constructor(data?: IGewerkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayId = _data["DisplayId"];
            this.bezeichnung = _data["Bezeichnung"];
        }
    }

    static fromJS(data: any): GewerkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GewerkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DisplayId"] = this.displayId;
        data["Bezeichnung"] = this.bezeichnung;
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten Gewerk-Daten */
export interface IGewerkDto {
    /** Extern anzeigbare ID des Gewerk-Objekts */
    displayId: string;
    /** Nummer des Gewerk-Objekts */
    bezeichnung?: string | undefined;
}

/** Enthält die für die Übertragung an andere Systeme relevanten AnfrageHochbauplaeneGebaeude-Daten */
export class AnfrageHochbauplaeneGebaeudeDto implements IAnfrageHochbauplaeneGebaeudeDto {
    /** E-Mail-Adresse des beantragenden Nutzers */
    userEmail?: string | undefined;
    /** Anzeigbare ID des ausgewählten We-Objekts */
    weDisplayId!: string;
    /** Anzeigbare ID des ausgewählten Grundstueck-Objekts */
    grundstueckDisplayId!: string;
    /** Anzeigbare ID des ausgewählten Gebaeude-Objekts */
    gebaeudeDisplayId!: string;
    /** Liste der ausgewählten Raum-Objekte */
    raeume?: AnfrageHochbauplaeneRaumDto[] | undefined;

    constructor(data?: IAnfrageHochbauplaeneGebaeudeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["UserEmail"];
            this.weDisplayId = _data["WeDisplayId"];
            this.grundstueckDisplayId = _data["GrundstueckDisplayId"];
            this.gebaeudeDisplayId = _data["GebaeudeDisplayId"];
            if (Array.isArray(_data["Raeume"])) {
                this.raeume = [] as any;
                for (let item of _data["Raeume"])
                    this.raeume!.push(AnfrageHochbauplaeneRaumDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnfrageHochbauplaeneGebaeudeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnfrageHochbauplaeneGebaeudeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserEmail"] = this.userEmail;
        data["WeDisplayId"] = this.weDisplayId;
        data["GrundstueckDisplayId"] = this.grundstueckDisplayId;
        data["GebaeudeDisplayId"] = this.gebaeudeDisplayId;
        if (Array.isArray(this.raeume)) {
            data["Raeume"] = [];
            for (let item of this.raeume)
                data["Raeume"].push(item.toJSON());
        }
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten AnfrageHochbauplaeneGebaeude-Daten */
export interface IAnfrageHochbauplaeneGebaeudeDto {
    /** E-Mail-Adresse des beantragenden Nutzers */
    userEmail?: string | undefined;
    /** Anzeigbare ID des ausgewählten We-Objekts */
    weDisplayId: string;
    /** Anzeigbare ID des ausgewählten Grundstueck-Objekts */
    grundstueckDisplayId: string;
    /** Anzeigbare ID des ausgewählten Gebaeude-Objekts */
    gebaeudeDisplayId: string;
    /** Liste der ausgewählten Raum-Objekte */
    raeume?: AnfrageHochbauplaeneRaumDto[] | undefined;
}

/** Enthält die für die Übertragung an andere Systeme relevanten AnfrageHochbauplaeneRaum-Daten */
export class AnfrageHochbauplaeneRaumDto implements IAnfrageHochbauplaeneRaumDto {
    /** Anzeigbare ID des ausgewählten Geschoss-Objekts */
    geschossDisplayId!: string;
    /** Anzeigbare ID des ausgewählten Raum-Objekts */
    raumDisplayId!: string;

    constructor(data?: IAnfrageHochbauplaeneRaumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geschossDisplayId = _data["GeschossDisplayId"];
            this.raumDisplayId = _data["RaumDisplayId"];
        }
    }

    static fromJS(data: any): AnfrageHochbauplaeneRaumDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnfrageHochbauplaeneRaumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GeschossDisplayId"] = this.geschossDisplayId;
        data["RaumDisplayId"] = this.raumDisplayId;
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten AnfrageHochbauplaeneRaum-Daten */
export interface IAnfrageHochbauplaeneRaumDto {
    /** Anzeigbare ID des ausgewählten Geschoss-Objekts */
    geschossDisplayId: string;
    /** Anzeigbare ID des ausgewählten Raum-Objekts */
    raumDisplayId: string;
}

/** Enthält die für die Übertragung an andere Systeme relevanten Benutzerdaten */
export class UserDto implements IUserDto {
    /** Name des Benutzers */
    userName?: string | undefined;
    /** Mailadresse des Benutzers */
    email?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["Email"] = this.email;
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten Benutzerdaten */
export interface IUserDto {
    /** Name des Benutzers */
    userName?: string | undefined;
    /** Mailadresse des Benutzers */
    email?: string | undefined;
}

/** Enthält Informationen zu HTTP-Links */
export class LinkDto implements ILinkDto {
    /** Eindeutige Adresse des Links */
    uri?: string | undefined;
    /** Text des Links */
    text?: string | undefined;

    constructor(data?: ILinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["Uri"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): LinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Uri"] = this.uri;
        data["Text"] = this.text;
        return data; 
    }
}

/** Enthält Informationen zu HTTP-Links */
export interface ILinkDto {
    /** Eindeutige Adresse des Links */
    uri?: string | undefined;
    /** Text des Links */
    text?: string | undefined;
}

/** Enthält die für die Übertragung an andere Systeme relevanten AnfrageStandortprognose-Daten */
export class AnfrageStandortprognoseDto implements IAnfrageStandortprognoseDto {
    /** E-Mail-Adresse des beantragenden Nutzers */
    userEmail?: string | undefined;
    /** Anzeigbare ID des ausgewählten We-Objekts */
    weDisplayId!: string;
    /** Anzeigbare ID des ausgewählten Grundstueck-Objekts */
    grundstueckDisplayId!: string;
    /** Anzeigbare ID des ausgewählten Gebaeude-Objekts */
    gebaeudeDisplayId!: string;
    /** Anzeigbare ID des ausgewählten Gewerk-Objekts */
    gewerkDisplayId!: string;
    /** Anzeigbare ID des ausgewählten Raum-Objekts */
    raumDisplayId?: string | undefined;

    constructor(data?: IAnfrageStandortprognoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["UserEmail"];
            this.weDisplayId = _data["WeDisplayId"];
            this.grundstueckDisplayId = _data["GrundstueckDisplayId"];
            this.gebaeudeDisplayId = _data["GebaeudeDisplayId"];
            this.gewerkDisplayId = _data["GewerkDisplayId"];
            this.raumDisplayId = _data["RaumDisplayId"];
        }
    }

    static fromJS(data: any): AnfrageStandortprognoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnfrageStandortprognoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserEmail"] = this.userEmail;
        data["WeDisplayId"] = this.weDisplayId;
        data["GrundstueckDisplayId"] = this.grundstueckDisplayId;
        data["GebaeudeDisplayId"] = this.gebaeudeDisplayId;
        data["GewerkDisplayId"] = this.gewerkDisplayId;
        data["RaumDisplayId"] = this.raumDisplayId;
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten AnfrageStandortprognose-Daten */
export interface IAnfrageStandortprognoseDto {
    /** E-Mail-Adresse des beantragenden Nutzers */
    userEmail?: string | undefined;
    /** Anzeigbare ID des ausgewählten We-Objekts */
    weDisplayId: string;
    /** Anzeigbare ID des ausgewählten Grundstueck-Objekts */
    grundstueckDisplayId: string;
    /** Anzeigbare ID des ausgewählten Gebaeude-Objekts */
    gebaeudeDisplayId: string;
    /** Anzeigbare ID des ausgewählten Gewerk-Objekts */
    gewerkDisplayId: string;
    /** Anzeigbare ID des ausgewählten Raum-Objekts */
    raumDisplayId?: string | undefined;
}

/** Enthält die für die Übertragung an andere Systeme relevanten We-Daten */
export class WeDto implements IWeDto {
    /** Extern anzeigbare ID des We-Objekts */
    displayId!: string;
    /** Nummer des We-Objekts */
    nummer?: string | undefined;
    /** Anzeigename des We-Objekts */
    anzeigename?: string | undefined;
    /** Adresse des des We-Objekts */
    adresse?: AdresseDto | undefined;
    /** Liste der dem We-Objekt zugeordneten
Grundstueck-Objekte */
    grundstuecke?: GrundstueckDto[] | undefined;

    constructor(data?: IWeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayId = _data["DisplayId"];
            this.nummer = _data["Nummer"];
            this.anzeigename = _data["Anzeigename"];
            this.adresse = _data["Adresse"] ? AdresseDto.fromJS(_data["Adresse"]) : <any>undefined;
            if (Array.isArray(_data["Grundstuecke"])) {
                this.grundstuecke = [] as any;
                for (let item of _data["Grundstuecke"])
                    this.grundstuecke!.push(GrundstueckDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DisplayId"] = this.displayId;
        data["Nummer"] = this.nummer;
        data["Anzeigename"] = this.anzeigename;
        data["Adresse"] = this.adresse ? this.adresse.toJSON() : <any>undefined;
        if (Array.isArray(this.grundstuecke)) {
            data["Grundstuecke"] = [];
            for (let item of this.grundstuecke)
                data["Grundstuecke"].push(item.toJSON());
        }
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten We-Daten */
export interface IWeDto {
    /** Extern anzeigbare ID des We-Objekts */
    displayId: string;
    /** Nummer des We-Objekts */
    nummer?: string | undefined;
    /** Anzeigename des We-Objekts */
    anzeigename?: string | undefined;
    /** Adresse des des We-Objekts */
    adresse?: AdresseDto | undefined;
    /** Liste der dem We-Objekt zugeordneten
Grundstueck-Objekte */
    grundstuecke?: GrundstueckDto[] | undefined;
}

/** Enthält die für die Übertragung an andere Systeme relevanten Grundstueck-Daten */
export class GrundstueckDto implements IGrundstueckDto {
    /** Extern anzeigbare ID des Grundstueck-Objekts */
    displayId!: string;
    /** Objekt-ID des Grundstueck-Objekts */
    objektId?: string | undefined;
    /** Nummer des Grundstueck-Objekts */
    nummer?: string | undefined;
    /** Anzeigename des Grundstueck-Objekts */
    anzeigename?: string | undefined;
    /** Liste der dem Grundstueck-Objekt zugeordneten
Gebaeude-Objekte */
    gebaeude?: GebaeudeDto[] | undefined;

    constructor(data?: IGrundstueckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayId = _data["DisplayId"];
            this.objektId = _data["ObjektId"];
            this.nummer = _data["Nummer"];
            this.anzeigename = _data["Anzeigename"];
            if (Array.isArray(_data["Gebaeude"])) {
                this.gebaeude = [] as any;
                for (let item of _data["Gebaeude"])
                    this.gebaeude!.push(GebaeudeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GrundstueckDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrundstueckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DisplayId"] = this.displayId;
        data["ObjektId"] = this.objektId;
        data["Nummer"] = this.nummer;
        data["Anzeigename"] = this.anzeigename;
        if (Array.isArray(this.gebaeude)) {
            data["Gebaeude"] = [];
            for (let item of this.gebaeude)
                data["Gebaeude"].push(item.toJSON());
        }
        return data; 
    }
}

/** Enthält die für die Übertragung an andere Systeme relevanten Grundstueck-Daten */
export interface IGrundstueckDto {
    /** Extern anzeigbare ID des Grundstueck-Objekts */
    displayId: string;
    /** Objekt-ID des Grundstueck-Objekts */
    objektId?: string | undefined;
    /** Nummer des Grundstueck-Objekts */
    nummer?: string | undefined;
    /** Anzeigename des Grundstueck-Objekts */
    anzeigename?: string | undefined;
    /** Liste der dem Grundstueck-Objekt zugeordneten
Gebaeude-Objekte */
    gebaeude?: GebaeudeDto[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}